/**
 * @generated SignedSource<<a52be15035360885eeb612c13ccc56ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MerchantStoreState = "INACTIVE" | "LIVE" | "RETIRED" | "UNKNOWN" | "%future added value";
export type useMerchantStoreMutationsRemoveMutation$variables = {
  id: string;
};
export type useMerchantStoreMutationsRemoveMutation$data = {
  readonly removeMerchantStore: {
    readonly errors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly fields: ReadonlyArray<string> | null | undefined;
      readonly message: string | null | undefined;
      readonly shortMessage: string | null | undefined;
      readonly vars: any | null | undefined;
    }>;
    readonly result: {
      readonly id: string;
      readonly state: MerchantStoreState | null | undefined;
    } | null | undefined;
  };
};
export type useMerchantStoreMutationsRemoveMutation = {
  response: useMerchantStoreMutationsRemoveMutation$data;
  variables: useMerchantStoreMutationsRemoveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "RemoveMerchantStoreResult",
    "kind": "LinkedField",
    "name": "removeMerchantStore",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MerchantStore",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fields",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vars",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMerchantStoreMutationsRemoveMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMerchantStoreMutationsRemoveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "20cef241e424d147a6c11a473daf62fa",
    "id": null,
    "metadata": {},
    "name": "useMerchantStoreMutationsRemoveMutation",
    "operationKind": "mutation",
    "text": "mutation useMerchantStoreMutationsRemoveMutation(\n  $id: ID!\n) {\n  removeMerchantStore(id: $id) {\n    result {\n      id\n      state\n    }\n    errors {\n      message\n      fields\n      code\n      shortMessage\n      vars\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bd7753070dd512205521eb16f927d3eb";

export default node;
